import React, { Fragment, useState, useRef, useEffect, useMemo } from "react";
import { Card } from "react-bootstrap";
import { Button, FormControlLabel, Switch } from "@material-ui/core";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import "./Reports.css";
import DQI_Summary from "./DQI_Summary";
import DQI_Config from "./DQI_Config";
import DQI_Detailed from "./DQI_Detailed";
import DQI_Monthly from "./DQI_Monthly";
import DownloadIcon from "@mui/icons-material/Download";
import ReactDOMServer from "react-dom/server";
import { useReactToPrint } from "react-to-print";
import { useSelector, useDispatch } from "react-redux";
import { getReportFilterData, getReportData } from "./../../Utils/actions/yh";
import { abbrNum, loadingOff, loadingOn } from "../../Utils/utils";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getApiUserRoles } from "../../Utils/actions";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import verasLogo from "./../../Assets/Images/verasLogo.png";
import chevronLogo from "./../../Assets/Images/chevronlogo.png";
import { thresholdColorsDqi } from "./../../Pages/YH/DqDummy";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import html2canvas from "html2canvas";
import { buttonStyle } from "../../Style/ManualStyle";

// export const getDQIColor = (value) => {
//  if (value < 20) {
//     return { backgroundColor: "#ffc7ce", color: "#9c0006" }; // Dark grey for poor
// }
// else if (value < 50) {
//     return { backgroundColor: "#fff2ce", color: "black" }; // Dark grey for poor
// }
// else if (value < 70) {
//     return { backgroundColor: "#ffeb9c", color: "#9c5700" }; // Dark grey for poor
// }
// else if (value < 90) {
//     return { backgroundColor: "#c6efce", color: "#006100" }; // Dark grey for poor
// }

// };

// export const getDQIColor = (value) => {

//     const matchingColor = thresholdColorsDqi?.thresholdColors?.find(colors => value < parseInt(colors.maxthresholdValue));

//     if (matchingColor) {
//         return { backgroundColor: matchingColor.backgroundColor, color: matchingColor.color };
//     }
// };

export const getSuperheadeingColor = () => {
  return { backgroundColor: "rgb(119 119 119)", color: "white" }; // Dark grey for poor
};
export const getSupersubeingColor = () => {
  return { backgroundColor: "rgb(163 162 162)", color: "white" }; // Dark grey for poor
};
export const getSubeingColor = () => {
  return { backgroundColor: "rgb(163 162 162)", color: "white" }; // Dark grey for poor
};
export const convertTimeStampToDate = (timestamp) => {
  const date = new Date(Number(timestamp));

  // Array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract year, month, and day from the Date object
  const year = date.getFullYear();
  const monthIndex = date.getMonth(); // Returns a zero-based month index
  const monthName = monthNames[monthIndex];
  const day = ("0" + date.getDate()).slice(-2);

  // Format the date as yyyy-month-dd
  return `${year}-${monthName}-${day}`;
};

const Reports = () => {
  const [clicked, setClicked] = useState(false);
  const [startIndex, setStartIndex] = useState(null);
  const [endIndex, setEndIndex] = useState(null);
  const [startMonth, setStartMonth] = useState(null);
  const [downloading, setDownloading] = useState(false);

  const dispatch = useDispatch();
  const { reportFilterData, reportData, loading, thresholdColorsDqi } =
    useSelector((state) => state.yh);
  useEffect(() => {}, []);

  useEffect(() => {
    dispatch(loadingOn());
    dispatch(getApiUserRoles(sessionStorage.getItem("username")));

    dispatch(getReportFilterData());
  }, []);

  const [selectedReport, setSelectedReport] = useState("summary");
  const handleReportChange = (event) => {
    setSelectedReport(event.target.value);
    setselectedBusinessUnit("all");
    setSelectedDataProvider("all");
    setSelectedRig("all");
    setSelectedWell("all");
    setSelectedLogName("all");
    setSelectedWellName("all");
    setSelectedLog("all");
    setSelectedMnemonic("all");
    setDepthStartIndex(null);
    setDepthEndIndex(null);
    setStartMonth(null);
    setStartIndex(null);
    setEndIndex(null);
    setSelectedLogType("all");
  };

  const timestampToDate = (timestamp) => {
    return new Date(timestamp); // Assuming the timestamp is in milliseconds
  };
  const [selectedBusinessUnit, setselectedBusinessUnit] = useState("all");
  const [selectedDataProvider, setSelectedDataProvider] = useState("all");
  const [selectedRig, setSelectedRig] = useState("all");
  const [selectedWell, setSelectedWell] = useState("all");
  const [selectedWellName, setSelectedWellName] = useState("all");
  const [selectedLogName, setSelectedLogName] = useState("all");

  const [selectedWellStartIndex, setSelectedWellStartIndex] = useState("all");
  const [selectedWellEndIndex, setSelectedWellEndIndex] = useState("all");

  const [selectedLog, setSelectedLog] = useState("all");
  const [selectedMnemonic, setSelectedMnemonic] = useState("all");
  const [reportComponent, setReportComponent] = useState();
  const [reportComponentFileName, setReportComponentFileName] = useState();
  const [switchErrorValue, setSwitchErrorValues] = useState(false);
  const [reportcontent, setReportcontent] = useState("");
  const [selectedLogType, setSelectedLogType] = useState("all");
  const [depthStartIndex, setDepthStartIndex] = useState("");
  const [depthEndIndex, setDepthEndIndex] = useState("");

  const [showMessage, setShowMessage] = useState(false);
  const [showGenerateReportMessage, setShowGenerateReportMessage] =
    useState(true);

  const determineLogType = (selectedLog) => {
    // You can implement your logic here to determine the log type based on the selected log
    // For demonstration, let's assume "Time Series" for logs containing "Time" in their name, otherwise "Depth Series"
    return selectedLog.toLowerCase().includes("time")
      ? "timeseries"
      : "depthseries";
  };

  const handleBusinessUnitChange = (event) => {
    setselectedBusinessUnit(event.target.value);
    setSelectedDataProvider("all");
    setSelectedRig("all");
    setSelectedWell("all");
    setSelectedLog("all");
    setSelectedMnemonic("all");
    setSelectedWellName("all");
    setSelectedLogName("all");
  };

  const handleDataProviderChange = (event) => {
    setSelectedDataProvider(event.target.value);
    setSelectedRig("all");
    setSelectedWell("all");
    setSelectedLog("all");
    setSelectedMnemonic("all");
    setSelectedWellName("all");
    setSelectedLogName("all");
  };
  const handleRigChange = (event) => {
    setSelectedRig(event.target.value);
    setSelectedWell("all");
    setSelectedWellName("all");
    setSelectedLogName("all");
    setSelectedLog("all");
    setSelectedMnemonic("all");
  };
  const handleWellChange = (event) => {
    const selectWellValues = event.target.value;

    setSelectedWell(event.target.value);
    setSelectedWellName(selectWellValues.name || event.target.value);

    // let startDate = null; // Initialize startDate as null

    // // Check if selectWellValues.start_index is a number (timestamp)
    // if (selectWellValues.start_index && selectWellValues.start_index !== "NOT CALCULATING") {
    //     startDate = timestampToDate(Number(selectWellValues.start_index)); // Convert to Date if it's a timestamp

    // }
    // setStartIndex(dayjs(startDate)); // Set startDate as the new value of startIndex

    // let endDate = null; // Initialize startDate as null

    // // Check if selectWellValues.start_index is a number (timestamp)
    // if (selectWellValues.end_index && selectWellValues.end_index !== "NOT CALCULATING") {
    //     endDate = timestampToDate(Number(selectWellValues.end_index)); // Convert to Date if it's a timestamp

    // }
    // setEndIndex(dayjs(endDate)); // Set startDate as the new value of startIndex

    setSelectedLog("all");
    setSelectedMnemonic("all");
  };
  useEffect(() => {}, [startIndex]); // Add startIndex as a dependency

  const handleLogChange = (event) => {
    setSelectedLog(event.target.value);

    const selectedLogValues = event.target.value;

    setSelectedLogName(selectedLogValues.name || event.target.value);

    let startDate = null; // Initialize startDate as null
    let endDate = null; // Initialize startDate as null
    let startInd = null;
    let endInd = null;
    if (selectedLogValues.indexType === "TIMESERIES") {
      setSelectedLogType("TIMESERIES");
      // Check if selectWellValues.start_index is a number (timestamp)
      if (
        selectedLogValues.startIndex &&
        selectedLogValues.startIndex !== "NOT CALCULATING"
      ) {
        startDate = timestampToDate(Number(selectedLogValues.startIndex)); // Convert to Date if it's a timestamp
      }
      setStartIndex(dayjs(startDate)); // Set startDate as the new value of startIndex

      // Check if selectWellValues.start_index is a number (timestamp)
      if (
        selectedLogValues.endIndex &&
        selectedLogValues.endIndex !== "NOT CALCULATING"
      ) {
        endDate = timestampToDate(Number(selectedLogValues.endIndex)); // Convert to Date if it's a timestamp
      }
      setEndIndex(dayjs(endDate)); // Set startDate as the new value of startIndex
      // let indexType = "all";
    }
    if (selectedLogValues.indexType === "DEPTHSERIES") {
      setSelectedLogType("DEPTHSERIES");
      // Check if selectWellValues.start_index is a number (timestamp)
      if (
        selectedLogValues.startIndex &&
        selectedLogValues.startIndex !== "NOT CALCULATING"
      ) {
        startInd = selectedLogValues.startIndex;
      }
      setDepthStartIndex(startInd); // Set startDate as the new value of startIndex

      // let endDate = null; // Initialize startDate as null

      // // Check if selectWellValues.start_index is a number (timestamp)
      if (
        selectedLogValues.endIndex &&
        selectedLogValues.endIndex !== "NOT CALCULATING"
      ) {
        endInd = selectedLogValues.endIndex; // Convert to Date if it's a timestamp
      }
      setDepthEndIndex(endInd); // Set startDate as the new value of startIndex
      // let indexType = "all";
    }

    setSelectedMnemonic("all");
  };
  const handleStartIndexChange = (date) => {
    setStartIndex(date);
  };
  const handleEndIndexChange = (date) => {
    setEndIndex(date);
  };

  const handleStartMonthChange = (newMonth) => {
    setStartMonth(newMonth);
  };

  // Function to calculate end month based on start month
  const calculateEndMonth = (start) => {
    return start.clone().add(1, "month");
  };

  // Calculate end month inside the component body or useEffect hook
  const endMonth = useMemo(
    () => (startMonth ? calculateEndMonth(startMonth) : null),
    [startMonth]
  );

  // Then use endMonth in your timestamp calculations

  const timestampGMTStart = new Date(startIndex || startMonth);
  const timestampOfStartIndex =
    timestampGMTStart.getTime() - timestampGMTStart.getTimezoneOffset() * 60000;

  const timestampGMTEnd = new Date(endIndex || endMonth);
  const timestampOfEndIndex =
    timestampGMTEnd.getTime() - timestampGMTEnd.getTimezoneOffset() * 60000;

  const timestampDate = 1734699652000;
  const converted = convertTimeStampToDate(timestampOfStartIndex);

  const handleLogTypeChange = (event) => {
    setSelectedLogType(event.target.value);
    setSelectedMnemonic("all");
  };
  const handleMnemonicChange = (event) => {
    setSelectedMnemonic(event.target.value);
  };
  const handleDepthStartIndex = (event) => {
    setDepthStartIndex(event.target.value);
  };
  const handleDepthEndIndex = (event) => {
    setDepthEndIndex(event.target.value);
  };

  useEffect(() => {
    if (reportData && clicked) {
      switch (selectedReport) {
        case "summary":
          setReportComponent(
            <DQI_Summary
              dqi_params={reportData}
              reportType="summary"
              thresholdColorsDqi={thresholdColorsDqi}
            />
          );
          setReportComponentFileName("DQI Summary Report");
          setClicked(false);
          break;
        case "config":
          setReportComponent(
            <DQI_Config
              dqi_params={reportData}
              isclicked={clicked}
              thresholdColorsDqi={thresholdColorsDqi}
            />
          );
          setReportComponentFileName("DQI Config Report");
          setClicked(false);
          break;
        case "detailed":
          setReportComponent(
            <DQI_Detailed
              dqi_params={reportData}
              thresholdColorsDqi={thresholdColorsDqi}
            />
          );
          setReportComponentFileName("DQI Detailed Report");
          setClicked(false);
          break;
        case "monthly":
          setReportComponent(
            <DQI_Monthly
              dqi_params={reportData}
              thresholdColorsDqi={thresholdColorsDqi}
            />
          );
          setReportComponentFileName("DQI Monthly Report");
          setClicked(false);
          break;
        default:
          setReportComponent(null);
          break;
      }
    }
  }, [reportData, selectedReport]);

  const generateReport = () => {
    // reportData = "";
    setClicked(true);
    setShowGenerateReportMessage(false);
    setShowMessage(true);
    dispatch(loadingOn());

    const startPoint =
      selectedLogType === "TIMESERIES" || selectedLogType === "all"
        ? startMonth || startIndex
          ? timestampOfStartIndex
          : null
        : depthStartIndex;

    const endPoint =
      selectedLogType === "TIMESERIES" || selectedLogType === "all"
        ? endIndex || endMonth
          ? timestampOfEndIndex
          : null
        : depthEndIndex;

    dispatch(
      getReportData(
        selectedReport,
        selectedBusinessUnit,
        selectedDataProvider,
        selectedRig,
        selectedWellName,
        selectedLogName,
        selectedMnemonic,
        selectedLogType,
        startPoint,
        endPoint,
        switchErrorValue
      )
    );
    setShowMessage(false);
  };

  const handleWellClick = (well) => {};

  const componentRef = useRef();
  const currentDate = new Date();
  const formattedDate = currentDate
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // Use 24-hour format
    })
    .replace(/\//g, "-")
    .replace(",", "")
    .replace(/\s/g, "-");

  // const handlePrint = useReactToPrint({
  //     content: () => componentRef.current,
  //     pageStyle: `
  //     @page {
  //       size: A4 landscape;
  //       margin: 0.6cm;
  //     }
  //   `,
  //     documentTitle: reportComponentFileName + "-" + formattedDate
  // });

  //     const handlePrint = () => {
  //         const customPageSize = {
  //             width: 890 * 1.5, // A1 width multiplied by 1.5
  //             height: 594.96 * 1.5 // A1 height multiplied by 1.5
  //         };

  //         const pdf = new jsPDF('landscape', 'px', [customPageSize.width, customPageSize.height]);
  // // Create a new PDF document

  //         const width = pdf.internal.pageSize.getWidth();
  //         const height = pdf.internal.pageSize.getHeight();
  //         const headerHeight = 100; // Height of the header
  //         const logoWidth = 100; // Width of each logo
  //         const logoHeight = 65; // Height of each logo
  //         const headerBackgroundColor = '#d3d3d3'; // Background color of the header
  //         const marginTop = 20;
  //         // Increment the startMonth and endMonth by one day
  //         const startDate = new Date(startMonth);
  //         startDate.setDate(startDate.getDate());

  //         const endDate = new Date(endMonth);
  //         endDate.setDate(endDate.getDate());
  //         const formattedStartDate = startDate.toLocaleString('en-GB', {
  //             day: '2-digit',
  //             month: '2-digit',
  //             year: 'numeric',
  //             hour: '2-digit',
  //             minute: '2-digit',
  //             hour12: false // Use 24-hour format
  //         }).replace(/\//g, '-').replace(',', '').replace(/\s/g, '-');

  //         const formattedEndDate = endDate.toLocaleString('en-GB', {
  //             day: '2-digit',
  //             month: '2-digit',
  //             year: 'numeric',
  //             hour: '2-digit',
  //             minute: '2-digit',
  //             hour12: false // Use 24-hour format
  //         }).replace(/\//g, '-').replace(',', '').replace(/\s/g, '-');

  //         let headerText = ''; // Define header text variable outside the conditional blocks
  //         if (selectedReport === 'summary') {
  //             headerText = `Daily DQI Summary for a Provider across Bus(for all the rigs and wells)\nData Provider: ${selectedDataProvider}\nReport Date: ${formattedDate}`
  //         }
  //         else if (selectedReport === 'detailed') {
  //             headerText = `DQI Detailed Report for a Provider across BUs(for all the rigs and wells)\nData Provider: ${selectedDataProvider}\nReport Date: ${formattedDate}`
  //         }
  //         else if (selectedReport === 'monthly') {
  //             if (selectedLogType === 'DEPTHSERIES') {
  //                 headerText = `DQI Monthly Report for a Provider across BUs (for all the rigs and wells)\nData Provider: ${selectedDataProvider}\nReport Date: ${formattedDate}\nReport Period From: ${depthStartIndex} to ${depthEndIndex}`;
  //             }
  //             else {
  //                 headerText = `DQI Monthly Report for a Provider across BUs (for all the rigs and wells)\nData Provider: ${selectedDataProvider}\nReport Date: ${formattedDate}\nReport Period From: ${formattedStartDate} to ${formattedEndDate}`;
  //             }
  //         }
  //         else {
  //             headerText = `DQI Config for a Provider across Bus(for all the rigs and wells)\nData Provider: ${selectedDataProvider}\nReport Date: ${formattedDate}`
  //         }

  //         // Add background color for the header
  //         pdf.setFillColor(headerBackgroundColor);
  //         pdf.rect(0, 0, customPageSize.width, headerHeight, 'F');

  //         // Calculate X position for the logos
  //         const leftLogoX = 10; // X position for the left logo
  //         const rightLogoX = width - logoWidth - 10; // X position for the right logo

  //         // Add left logo
  //         const leftLogoData = chevronLogo; // Specify the path to your left logo image
  //         pdf.addImage(leftLogoData, 'JPEG', leftLogoX, 10, logoWidth, logoHeight); // Adjust position and size as needed

  //         // Add right logo
  //         const rightLogoData = verasLogo; // Specify the path to your right logo image
  //         pdf.addImage(rightLogoData, 'JPEG', rightLogoX, 10, logoWidth, logoHeight); // Adjust position and size as needed

  //         // Add header text
  //         pdf.setFontSize(20); // Set font size for the header text
  //         pdf.setTextColor('#000000'); // Text color for the header

  //         // Calculate width of the header text
  //         // const marginLeft = 200;
  //         pdf.text(headerText, width / 2, 30, { align: 'center' }); // Center the header text horizontally
  //         // Display header text

  //         // Add content below the header
  //         // Replace componentRef with your actual reference to the HTML content
  //         pdf.html(componentRef.current, {
  //             x: 10,
  //             y: headerHeight + 10 + marginTop, // Start Y position for content (below the header) + marginTop
  //             callback: () => {
  //                 pdf.save(reportComponentFileName + "-" + formattedDate + ".pdf"); // Save the PDF
  //             }
  //         });
  //     };

  const handlePrint = () => {
    setDownloading(true);
    const customPageSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    const pdf = new jsPDF("landscape", "px", [
      customPageSize.width,
      customPageSize.height,
    ]);

    const logoWidthLeft = 60; // Width of the left logo
    const logoWidthRight = 80; // Width of the right logo
    const logoHeight = 50; // Height of each logo
    const marginTop = 20;
    const marginBottom = 20;

    // Function to add header
    const addHeader = (headerText) => {
      const headerHeight = 100; // Height of the header
      const headerBackgroundColor = "#f2f2f2"; // Background color of the header
      const width = pdf.internal.pageSize.getWidth();

      pdf.setFillColor(headerBackgroundColor);
      pdf.rect(0, 0, width, headerHeight, "F");

      const leftLogoX = 10;
      const rightLogoX = width - logoWidthRight - 10; // Adjusted width for the right logo
      const leftLogoData = chevronLogo;
      const rightLogoData = verasLogo;

      pdf.addImage(
        leftLogoData,
        "JPEG",
        leftLogoX,
        10,
        logoWidthLeft,
        logoHeight
      ); // Use logoWidthLeft for the left logo
      pdf.addImage(
        rightLogoData,
        "JPEG",
        rightLogoX,
        10,
        logoWidthRight,
        logoHeight
      ); // Use logoWidthRight for the right logo

      pdf.setFontSize(20);
      pdf.setTextColor("#000000");

      // Split the header text into two parts to apply styles only to the specific part
      const headerParts = headerText.split("\n");
      const mainHeaderText = headerParts[0]; // First line of the header text
      const secondaryHeaderText = headerParts.slice(1).join("\n"); // Remaining lines

      // Apply styles to the main header text
      pdf.setFont("helvetica", "bold"); // Apply bold font style
      pdf.setFontSize(30); // Apply bold font style
      pdf.text(mainHeaderText, width / 2, 30, { align: "center" });

      // Apply default styles to the secondary header text
      pdf.setFont("helvetica", "normal"); // Reset font style
      pdf.setFontSize(20); // Apply bold font style

      pdf.text(secondaryHeaderText, width / 2, 50, { align: "center" });
    };

    // Function to add content
    const addContent = () => {
      // Replace componentRef with your actual reference to the HTML content
      pdf.html(componentRef.current, {
        x: 30,
        y: 130, // Start Y position for content (below the header)
        callback: () => {
          pdf.save(reportComponentFileName + "-" + formattedDate + ".pdf"); // Save the PDF
          setDownloading(false);
        },
      });
    };

    // Increment the startMonth and endMonth by one day
    const startDate = new Date(startMonth);
    startDate.setDate(startDate.getDate());
    const endDate = new Date(endMonth);
    endDate.setDate(endDate.getDate());
    const formattedStartDate = startDate
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false, // Use 24-hour format
      })
      .replace(/\//g, "-")
      .replace(",", "")
      .replace(/\s/g, "-");

    const formattedEndDate = endDate
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false, // Use 24-hour format
      })
      .replace(/\//g, "-")
      .replace(",", "")
      .replace(/\s/g, "-");

    let headerText = ""; // Define header text variable outside the conditional blocks
    if (selectedReport === "summary") {
      headerText = `Daily DQI Summary for a Provider across Bus(for all the rigs and wells)\nData Provider: ${selectedDataProvider}\nReport Date: ${formattedDate}`;
    } else if (selectedReport === "detailed") {
      headerText = `DQI Detailed Report for a Provider across BUs(for all the rigs and wells)\nData Provider: ${selectedDataProvider}\nReport Date: ${formattedDate}`;
    } else if (selectedReport === "monthly") {
      if (selectedLogType === "DEPTHSERIES") {
        headerText = `DQI Monthly Report for a Provider across BUs (for all the rigs and wells)\nData Provider: ${selectedDataProvider}\nReport Date: ${formattedDate}\nReport Period From: ${depthStartIndex} to ${depthEndIndex}`;
      } else {
        headerText = `DQI Monthly Report for a Provider across BUs (for all the rigs and wells)\nData Provider: ${selectedDataProvider}\nReport Date: ${formattedDate}\nReport Period From: ${formattedStartDate} to ${formattedEndDate}`;
      }
    } else {
      headerText = `DQI Config for a Provider across Bus(for all the rigs and wells)\nData Provider: ${selectedDataProvider}\nReport Date: ${formattedDate}`;
    }

    // Add header on the first page
    addHeader(headerText);

    // Add content on the first page
    addContent();
  };

  const downloadReport = () => {
    var printContents = document.getElementById("report-content").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  return (
    reportFilterData?.data && (
      <Fragment>
        {downloading ? (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999, // Ensure it's above other content
            }}
          >
            <p style={{ color: "#4e95d9", fontSize: "24px" }}>Downloading...</p>
          </div>
        ) : (
          ""
        )}
        <Card
          className={"reports-card"}
          style={{
            backgroundColor: "#333333",
            padding: "15px",
            overflow: "auto",
            height: "89vh",
            border: "none",
          }}
        >
          <Card.Body
            className={"reports-content"}
            style={{
              overflow: "auto",
              padding: "0px",
              background: "#242424",
              borderRadius: "5px",
            }}
          >
            <div
              className={`col-md-12 `}
              style={{ paddingTop: "35px", paddingRight: "0px" }}
            >
              <div className="dropdown-header d-flex">
                <div className="mr-2">
                  <FormControl
                    fullWidth
                    style={{ width: "200px" }}
                    className="dropdownHeight"
                  >
                    <InputLabel>Select a Report Type</InputLabel>
                    <Select
                      value={selectedReport}
                      onChange={handleReportChange}
                      label="Select a Report Type"
                    >
                      <MenuItem value="summary">
                        DQI Well Summary Report
                      </MenuItem>
                      {/* <MenuItem value="channel_summary">DQI Channel Summary Report</MenuItem> */}
                      {/* <MenuItem value="config">DQI Config Report</MenuItem> */}
                      <MenuItem value="detailed">DQI Detailed Report</MenuItem>
                      <MenuItem value="monthly">DQI Monthly Report</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="mr-2">
                  <FormControl
                    fullWidth
                    style={{ width: "150px" }}
                    className="dropdownHeight"
                  >
                    <InputLabel>Select a Business Unit</InputLabel>
                    <Select
                      value={selectedBusinessUnit}
                      onChange={handleBusinessUnitChange}
                      label="Select Business Unit"
                    >
                      <MenuItem value="all">ALL</MenuItem>
                      {reportFilterData.data.businessUnit.map(
                        (businessUnit, index) => (
                          <MenuItem key={index} value={businessUnit.name}>
                            {businessUnit.name}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </div>
                <div className="mr-2">
                  <FormControl
                    fullWidth
                    style={{ width: "150px" }}
                    className="dropdownHeight"
                  >
                    <InputLabel>Select a Data Provider</InputLabel>
                    <Select
                      value={selectedDataProvider}
                      onChange={handleDataProviderChange}
                      label="Select a Data Provider"
                    >
                      <MenuItem value="all">ALL</MenuItem>
                      {selectedBusinessUnit === "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .map((dataProvider) => dataProvider.name)
                            )
                          ).map((dataProvider, index) => (
                            <MenuItem key={index} value={dataProvider}>
                              {dataProvider}
                            </MenuItem>
                          ))
                        : reportFilterData.data.businessUnit
                            .find(
                              (businessUnit) =>
                                businessUnit.name === selectedBusinessUnit
                            )
                            ?.dataProviders.map((dataProvider, index) => (
                              <MenuItem key={index} value={dataProvider.name}>
                                {dataProvider.name}
                              </MenuItem>
                            ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="mr-2">
                  <FormControl
                    fullWidth
                    style={{ width: "150px" }}
                    className="dropdownHeight"
                  >
                    <InputLabel>Select a Rig</InputLabel>
                    <Select
                      value={selectedRig}
                      onChange={handleRigChange}
                      label="Select a Rig"
                    >
                      <MenuItem value="all">ALL</MenuItem>
                      {/* {selectedDataProvider === "all" && selectedBusinessUnit === "all" ?
                                                reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).flat().flatMap(dataProvider => dataProvider.rigs).flat().map((rig, index) => (
                                                    <MenuItem key={index} value={rig.name}>{rig.name}</MenuItem>
                                                )) : selectedDataProvider !== "all" && selectedBusinessUnit !== "all" ?
                                                    reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.map((rig, index) => (
                                                        <MenuItem key={index} value={rig.name}>{rig.name}</MenuItem>
                                                    )) :
                                                    selectedDataProvider === "all" && selectedBusinessUnit !== "all" ?
                                                        reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.flatMap(dataProvider => dataProvider.rigs).flat().map((rig, index) => (
                                                            <MenuItem key={index} value={rig.name}>{rig.name}</MenuItem>
                                                        )) :
                                                        reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.map((rig, index) => (
                                                            <MenuItem key={index} value={rig.name}>{rig.name}</MenuItem>
                                                        ))
                                            } */}

                      {selectedDataProvider === "all" &&
                      selectedBusinessUnit === "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .flatMap((dataProvider) => dataProvider.rigs)
                                .map((rig) => rig.name)
                            )
                          ).map((rigName, index) => (
                            <MenuItem key={index} value={rigName}>
                              {rigName}
                            </MenuItem>
                          ))
                        : selectedDataProvider !== "all" &&
                          selectedBusinessUnit !== "all"
                        ? Array.from(
                            new Set(
                              (
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )?.rigs || []
                              ).map((rig) => rig.name)
                            )
                          ).map((rigName, index) => (
                            <MenuItem key={index} value={rigName}>
                              {rigName}
                            </MenuItem>
                          ))
                        : selectedDataProvider === "all" &&
                          selectedBusinessUnit !== "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .find(
                                  (businessUnit) =>
                                    businessUnit.name === selectedBusinessUnit
                                )
                                ?.dataProviders.flatMap(
                                  (dataProvider) => dataProvider.rigs
                                )
                                .map((rig) => rig.name) || []
                            )
                          ).map((rigName, index) => (
                            <MenuItem key={index} value={rigName}>
                              {rigName}
                            </MenuItem>
                          ))
                        : Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .find(
                                  (dataProvider) =>
                                    dataProvider.name === selectedDataProvider
                                )
                                ?.rigs.map((rig) => rig.name) || []
                            )
                          ).map((rigName, index) => (
                            <MenuItem key={index} value={rigName}>
                              {rigName}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="mr-2">
                  <FormControl
                    fullWidth
                    style={{ width: "150px" }}
                    className="dropdownHeight"
                  >
                    <InputLabel>Select a Well</InputLabel>
                    <Select
                      value={selectedWell}
                      onChange={handleWellChange}
                      label="Select a Well"
                    >
                      <MenuItem value="all">ALL</MenuItem>
                      {/* {selectedBusinessUnit === "all" && selectedDataProvider === "all" && selectedRig === "all" ?
                                                reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).flat().flatMap(dataProvider => dataProvider.rigs).flat().flatMap(rig => rig.wells).flat().map((well, index) => (
                                                    <MenuItem key={index} value={well}>{well.name}</MenuItem>
                                                )) :
                                                selectedBusinessUnit !== "all" && selectedDataProvider !== "all" && selectedRig !== "all" ?
                                                    reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.find(rig => rig.name === selectedRig)?.wells.map((well, index) => (
                                                        <MenuItem key={index} value={well}>{well.name}</MenuItem>
                                                    )) :
                                                    selectedBusinessUnit !== "all" && selectedDataProvider === "all" && selectedRig === "all" ?
                                                        reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.flatMap(dataProvider => dataProvider.rigs).flat().flatMap(rig => rig.wells).flat().map((well, index) => (
                                                            <MenuItem key={index} value={well}>{well.name}</MenuItem>
                                                        )) :
                                                        selectedBusinessUnit !== "all" && selectedDataProvider !== "all" && selectedRig === "all" ?
                                                            reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.flatMap(rig => rig.wells).flat().map((well, index) => (
                                                                <MenuItem key={index} value={well}>{well.name}</MenuItem>
                                                            )) :
                                                            selectedBusinessUnit === "all" && selectedDataProvider !== "all" && selectedRig === "all" ?
                                                                reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.flatMap(rig => rig.wells).flat().map((well, index) => (
                                                                    <MenuItem key={index} value={well}>{well.name}</MenuItem>
                                                                )) :
                                                                selectedBusinessUnit === "all" && selectedDataProvider === "all" && selectedRig !== "all" ?
                                                                    reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).flat().flatMap(dataProvider => dataProvider.rigs).find(rig => rig.name === selectedRig)?.wells.map((well, index) => (
                                                                        <MenuItem key={index} value={well}>{well.name}</MenuItem>
                                                                    )) :
                                                                    selectedBusinessUnit === "all" && selectedDataProvider !== "all" && selectedRig !== "all" ?
                                                                        reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.find(rig => rig.name === selectedRig)?.wells.map((well, index) => (
                                                                            <MenuItem key={index} value={well}>{well.name}</MenuItem>
                                                                        )) :
                                                                        selectedBusinessUnit !== "all" && selectedDataProvider === "all" && selectedRig !== "all" ?
                                                                            reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.flatMap(dataProvider => dataProvider.rigs).find(rig => rig.name === selectedRig)?.wells.map((well, index) => (
                                                                                <MenuItem key={index} value={well}>{well.name}</MenuItem>
                                                                            )) : ""
                                            } */}
                      {selectedBusinessUnit === "all" &&
                      selectedDataProvider === "all" &&
                      selectedRig === "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .flatMap((dataProvider) => dataProvider.rigs)
                                .flatMap((rig) => rig.wells)
                                .map((well) => well.name)
                            )
                          ).map((wellName, index) => (
                            <MenuItem key={index} value={wellName}>
                              {wellName}
                            </MenuItem>
                          ))
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig !== "all"
                        ? Array.from(
                            new Set(
                              (
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.find((rig) => rig.name === selectedRig)
                                  ?.wells || []
                              ).map((well) => well.name)
                            )
                          ).map((wellName, index) => (
                            <MenuItem key={index} value={wellName}>
                              {wellName}
                            </MenuItem>
                          ))
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider === "all" &&
                          selectedRig === "all"
                        ? Array.from(
                            new Set(
                              (
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.flatMap(
                                    (dataProvider) => dataProvider.rigs
                                  )
                                  .flatMap((rig) => rig.wells) || []
                              ).map((well) => well.name)
                            )
                          ).map((wellName, index) => (
                            <MenuItem key={index} value={wellName}>
                              {wellName}
                            </MenuItem>
                          ))
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig === "all"
                        ? Array.from(
                            new Set(
                              (
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.flatMap((rig) => rig.wells) || []
                              ).map((well) => well.name)
                            )
                          ).map((wellName, index) => (
                            <MenuItem key={index} value={wellName}>
                              {wellName}
                            </MenuItem>
                          ))
                        : selectedBusinessUnit === "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig === "all"
                        ? Array.from(
                            new Set(
                              (
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.flatMap((rig) => rig.wells) || []
                              ).map((well) => well.name)
                            )
                          ).map((wellName, index) => (
                            <MenuItem key={index} value={wellName}>
                              {wellName}
                            </MenuItem>
                          ))
                        : selectedBusinessUnit === "all" &&
                          selectedDataProvider === "all" &&
                          selectedRig !== "all"
                        ? Array.from(
                            new Set(
                              (
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .flatMap((dataProvider) => dataProvider.rigs)
                                  .find((rig) => rig.name === selectedRig)
                                  ?.wells || []
                              ).map((well) => well.name)
                            )
                          ).map((wellName, index) => (
                            <MenuItem key={index} value={wellName}>
                              {wellName}
                            </MenuItem>
                          ))
                        : selectedBusinessUnit === "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig !== "all"
                        ? Array.from(
                            new Set(
                              (
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.find((rig) => rig.name === selectedRig)
                                  ?.wells || []
                              ).map((well) => well.name)
                            )
                          ).map((wellName, index) => (
                            <MenuItem key={index} value={wellName}>
                              {wellName}
                            </MenuItem>
                          ))
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider === "all" &&
                          selectedRig !== "all"
                        ? Array.from(
                            new Set(
                              (
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.flatMap(
                                    (dataProvider) => dataProvider.rigs
                                  )
                                  .find((rig) => rig.name === selectedRig)
                                  ?.wells || []
                              ).map((well) => well.name)
                            )
                          ).map((wellName, index) => (
                            <MenuItem key={index} value={wellName}>
                              {wellName}
                            </MenuItem>
                          ))
                        : ""}
                    </Select>
                  </FormControl>
                </div>
                <div className="mr-2">
                  <FormControl
                    fullWidth
                    style={{ width: "150px" }}
                    className="dropdownHeight"
                  >
                    <InputLabel>Select a Log</InputLabel>
                    <Select
                      value={selectedLog}
                      onChange={handleLogChange}
                      label="Select a Log"
                    >
                      <MenuItem value="all">ALL</MenuItem>
                      {/* {selectedBusinessUnit === "all" && selectedDataProvider === "all" && selectedRig === "all" && selectedWell === "all" ?
                                                reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).flat().flatMap(dataProvider => dataProvider.rigs).flat().flatMap(rig => rig.wells).flat().flatMap(well => well.logs).flat().map((log, index) => (
                                                    <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                )) :
                                                selectedBusinessUnit !== "all" && selectedDataProvider !== "all" && selectedRig !== "all" && selectedWell !== "all" ?
                                                    reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.find(rig => rig.name === selectedRig)?.wells.find(well => well.name === selectedWellName).logs.map((log, index) => (
                                                        log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                    )) :
                                                    selectedBusinessUnit !== "all" && selectedDataProvider !== "all" && selectedRig !== "all" && selectedWell === "all" ?
                                                        reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.find(rig => rig.name === selectedRig)?.wells.flatMap(well => well.logs).flat().map((log, index) => (
                                                            log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                        )) :
                                                        selectedBusinessUnit !== "all" && selectedDataProvider !== "all" && selectedRig === "all" && selectedWell === "all" ?
                                                            reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.flatMap(rig => rig.wells)?.flat().flatMap(well => well.logs).flat().map((log, index) => (
                                                                log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                            )) :
                                                            selectedBusinessUnit !== "all" && selectedDataProvider === "all" && selectedRig === "all" && selectedWell === "all" ?
                                                                reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.flatMap(dataProvider => dataProvider.rigs)?.flat().flatMap(rig => rig.wells)?.flat().flatMap(well => well.logs).flat().map((log, index) => (
                                                                    log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                )) :
                                                                selectedBusinessUnit === "all" && selectedDataProvider === "all" && selectedRig === "all" && selectedWell !== "all" ?
                                                                    reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).flat().flatMap(dataProvider => dataProvider.rigs)?.flat().flatMap(rig => rig.wells)?.find(well => well.name === selectedWellName)?.logs.map((log, index) => (
                                                                        log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                    )) :
                                                                    selectedBusinessUnit === "all" && selectedDataProvider === "all" && selectedRig !== "all" && selectedWell !== "all" ?
                                                                        reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).flat().flatMap(dataProvider => dataProvider.rigs)?.find(rig => rig.name === selectedRig)?.wells.find(well => well.name === selectedWellName)?.logs.map((log, index) => (
                                                                            log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                        )) :
                                                                        selectedBusinessUnit === "all" && selectedDataProvider !== "all" && selectedRig !== "all" && selectedWell !== "all" ?
                                                                            reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.find(rig => rig.name === selectedRig)?.wells.find(well => well.name === selectedWellName)?.logs.map((log, index) => (
                                                                                log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                            )) :
                                                                            selectedBusinessUnit === "all" && selectedDataProvider !== "all" && selectedRig !== "all" && selectedWell === "all" ?
                                                                                reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.find(rig => rig.name === selectedRig)?.wells.flatMap(well => well.logs)?.flat().map((log, index) => (
                                                                                    log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                                )) :
                                                                                selectedBusinessUnit === "all" && selectedDataProvider !== "all" && selectedRig === "all" && selectedWell === "all" ?
                                                                                    reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.flatMap(rig => rig.wells)?.flat().flatMap(well => well.logs).flat().map((log, index) => (
                                                                                        log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                                    )) :
                                                                                    selectedBusinessUnit === "all" && selectedDataProvider === "all" && selectedRig !== "all" && selectedWell === "all" ?
                                                                                        reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).flat().flatMap(dataProvider => dataProvider.rigs)?.find(rig => rig.name === selectedRig)?.wells.flatMap(well => well.logs).flat().map((log, index) => (
                                                                                            log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                                        )) :
                                                                                        selectedBusinessUnit !== "all" && selectedDataProvider === "all" && selectedRig !== "all" && selectedWell === "all" ?
                                                                                            reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.flatMap(dataProvider => dataProvider.rigs)?.find(rig => rig.name === selectedRig)?.wells.flatMap(well => well.logs).flat().map((log, index) => (
                                                                                                log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                                            )) :
                                                                                            selectedBusinessUnit !== "all" && selectedDataProvider === "all" && selectedRig !== "all" && selectedWell !== "all" ?
                                                                                                reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.flatMap(dataProvider => dataProvider.rigs)?.find(rig => rig.name === selectedRig)?.wells.find(well => well.name === selectedWellName)?.logs.map((log, index) => (
                                                                                                    log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                                                )) :
                                                                                                selectedBusinessUnit !== "all" && selectedDataProvider !== "all" && selectedRig === "all" && selectedWell !== "all" ?
                                                                                                    reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.flatMap(rig => rig.wells)?.find(well => well.name === selectedWellName)?.logs.map((log, index) => (
                                                                                                        log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                                                    )) :
                                                                                                    selectedBusinessUnit === "all" && selectedDataProvider !== "all" && selectedRig === "all" && selectedWell !== "all" ?
                                                                                                        reportFilterData.data.businessUnit.flatMap(businessUnit => businessUnit.dataProviders).find(dataProvider => dataProvider.name === selectedDataProvider)?.rigs.flatMap(rig => rig.wells)?.find(well => well.name === selectedWellName)?.logs.map((log, index) => (
                                                                                                            log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                                                        )) :
                                                                                                        selectedBusinessUnit !== "all" && selectedDataProvider === "all" && selectedRig === "all" && selectedWell !== "all" ?
                                                                                                            reportFilterData.data.businessUnit.find(businessUnit => businessUnit.name === selectedBusinessUnit)?.dataProviders.flatMap(dataProvider => dataProvider.rigs)?.flat().flatMap(rig => rig.wells).find(well => well.name === selectedWellName)?.logs.map((log, index) => (
                                                                                                                log.name && <MenuItem key={index} value={log}>{log.name}</MenuItem>
                                                                                                            )) : ""
                                            } */}
                      {selectedBusinessUnit === "all" &&
                      selectedDataProvider === "all" &&
                      selectedRig === "all" &&
                      selectedWell === "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .flat()
                                .flatMap((dataProvider) => dataProvider.rigs)
                                .flat()
                                .flatMap((rig) => rig.wells)
                                .flat()
                                .flatMap((well) => well.logs)
                                .flat()
                                .map((log) => log.name)
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig !== "all" &&
                          selectedWell !== "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .find(
                                  (businessUnit) =>
                                    businessUnit.name === selectedBusinessUnit
                                )
                                ?.dataProviders.find(
                                  (dataProvider) =>
                                    dataProvider.name === selectedDataProvider
                                )
                                ?.rigs.find((rig) => rig.name === selectedRig)
                                ?.wells.find(
                                  (well) => well.name === selectedWellName
                                )
                                .logs.map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig !== "all" &&
                          selectedWell === "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .find(
                                  (businessUnit) =>
                                    businessUnit.name === selectedBusinessUnit
                                )
                                ?.dataProviders.find(
                                  (dataProvider) =>
                                    dataProvider.name === selectedDataProvider
                                )
                                ?.rigs.find((rig) => rig.name === selectedRig)
                                ?.wells.flatMap((well) => well.logs)
                                .flat()
                                .map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig === "all" &&
                          selectedWell === "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .find(
                                  (businessUnit) =>
                                    businessUnit.name === selectedBusinessUnit
                                )
                                ?.dataProviders.find(
                                  (dataProvider) =>
                                    dataProvider.name === selectedDataProvider
                                )
                                ?.rigs.flatMap((rig) => rig.wells)
                                .flat()
                                .flatMap((well) => well.logs)
                                .flat()
                                .map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider === "all" &&
                          selectedRig === "all" &&
                          selectedWell === "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .find(
                                  (businessUnit) =>
                                    businessUnit.name === selectedBusinessUnit
                                )
                                ?.dataProviders.flatMap(
                                  (dataProvider) => dataProvider.rigs
                                )
                                .flat()
                                .flatMap((rig) => rig.wells)
                                .flat()
                                .flatMap((well) => well.logs)
                                .flat()
                                .map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit === "all" &&
                          selectedDataProvider === "all" &&
                          selectedRig === "all" &&
                          selectedWell !== "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .flat()
                                .flatMap((dataProvider) => dataProvider.rigs)
                                .flat()
                                .flatMap((rig) => rig.wells)
                                .find((well) => well.name === selectedWellName)
                                ?.logs.map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit === "all" &&
                          selectedDataProvider === "all" &&
                          selectedRig !== "all" &&
                          selectedWell !== "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .flat()
                                .flatMap((dataProvider) => dataProvider.rigs)
                                .flat()
                                .find((rig) => rig.name === selectedRig)
                                ?.wells.find(
                                  (well) => well.name === selectedWellName
                                )
                                ?.logs.map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit === "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig !== "all" &&
                          selectedWell !== "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .find(
                                  (dataProvider) =>
                                    dataProvider.name === selectedDataProvider
                                )
                                ?.rigs.find((rig) => rig.name === selectedRig)
                                ?.wells.find(
                                  (well) => well.name === selectedWellName
                                )
                                ?.logs.map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit === "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig !== "all" &&
                          selectedWell === "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .find(
                                  (dataProvider) =>
                                    dataProvider.name === selectedDataProvider
                                )
                                ?.rigs.find((rig) => rig.name === selectedRig)
                                ?.wells.flatMap((well) => well.logs)
                                .flat()
                                .map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit === "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig === "all" &&
                          selectedWell === "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .find(
                                  (dataProvider) =>
                                    dataProvider.name === selectedDataProvider
                                )
                                ?.rigs.flatMap((rig) => rig.wells)
                                .flat()
                                .flatMap((well) => well.logs)
                                .flat()
                                .map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit === "all" &&
                          selectedDataProvider === "all" &&
                          selectedRig !== "all" &&
                          selectedWell === "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .flat()
                                .flatMap((dataProvider) => dataProvider.rigs)
                                .find((rig) => rig.name === selectedRig)
                                ?.wells.flatMap((well) => well.logs)
                                .flat()
                                .map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider === "all" &&
                          selectedRig !== "all" &&
                          selectedWell === "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .find(
                                  (businessUnit) =>
                                    businessUnit.name === selectedBusinessUnit
                                )
                                ?.dataProviders.flatMap(
                                  (dataProvider) => dataProvider.rigs
                                )
                                .find((rig) => rig.name === selectedRig)
                                ?.wells.flatMap((well) => well.logs)
                                .flat()
                                .map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider === "all" &&
                          selectedRig !== "all" &&
                          selectedWell !== "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .find(
                                  (businessUnit) =>
                                    businessUnit.name === selectedBusinessUnit
                                )
                                ?.dataProviders.flatMap(
                                  (dataProvider) => dataProvider.rigs
                                )
                                .find((rig) => rig.name === selectedRig)
                                ?.wells.find(
                                  (well) => well.name === selectedWellName
                                )
                                ?.logs.map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig === "all" &&
                          selectedWell !== "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .find(
                                  (businessUnit) =>
                                    businessUnit.name === selectedBusinessUnit
                                )
                                ?.dataProviders.find(
                                  (dataProvider) =>
                                    dataProvider.name === selectedDataProvider
                                )
                                ?.rigs.flatMap((rig) => rig.wells)
                                .find((well) => well.name === selectedWellName)
                                ?.logs.map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit === "all" &&
                          selectedDataProvider !== "all" &&
                          selectedRig === "all" &&
                          selectedWell !== "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .flatMap(
                                  (businessUnit) => businessUnit.dataProviders
                                )
                                .find(
                                  (dataProvider) =>
                                    dataProvider.name === selectedDataProvider
                                )
                                ?.rigs.flatMap((rig) => rig.wells)
                                .find((well) => well.name === selectedWellName)
                                ?.logs.map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : selectedBusinessUnit !== "all" &&
                          selectedDataProvider === "all" &&
                          selectedRig === "all" &&
                          selectedWell !== "all"
                        ? Array.from(
                            new Set(
                              reportFilterData.data.businessUnit
                                .find(
                                  (businessUnit) =>
                                    businessUnit.name === selectedBusinessUnit
                                )
                                ?.dataProviders.flatMap(
                                  (dataProvider) => dataProvider.rigs
                                )
                                .flat()
                                .flatMap((rig) => rig.wells)
                                .find((well) => well.name === selectedWellName)
                                ?.logs.map((log) => log.name) || []
                            )
                          ).map(
                            (logName, index) =>
                              logName && (
                                <MenuItem key={index} value={logName}>
                                  {logName}
                                </MenuItem>
                              )
                          )
                        : ""}
                    </Select>
                  </FormControl>
                </div>
                <div className="mr-2">
                  <FormControl
                    fullWidth
                    style={{ width: "150px" }}
                    className="dropdownHeight"
                  >
                    <InputLabel>Select a Log Type</InputLabel>
                    <Select
                      value={selectedLogType}
                      onChange={handleLogTypeChange}
                      label="Select a Log Type"
                    >
                      <MenuItem value="all">ALL</MenuItem>

                      <MenuItem value="TIMESERIES">Time Series</MenuItem>
                      <MenuItem value="DEPTHSERIES">Depth Series</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                {selectedLogType === "DEPTHSERIES" ? (
                  <Fragment>
                    <div className="mr-2">
                      <TextField
                        label="Start Index"
                        value={depthStartIndex}
                        onChange={handleDepthStartIndex}
                        size="small"
                      />
                    </div>
                    <div className="mr-2">
                      <TextField
                        label="End Index"
                        value={depthEndIndex}
                        onChange={handleDepthEndIndex}
                        size="small"
                      />
                    </div>
                  </Fragment>
                ) : selectedReport === "monthly" ? (
                  <Fragment>
                    <div className="mr-2">
                      <style>
                        {`
           .reports-content .dropdown-header > .mr-2 > div .MuiFormControl-root .MuiInputLabel-outlined {
            top: -9px !important;
            position: absolute;
        }
        
        .reports-content .dropdown-header > .mr-2 > div .MuiFormControl-root:focus-within .MuiInputLabel-outlined {
            top: 0 !important;
        }
         
        `}
                      </style>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DateTimePicker", "DateTimePicker"]}
                        >
                          <DateTimePicker
                            label="Start Month"
                            value={startMonth}
                            onChange={handleStartMonthChange}
                            format="YYYY-MM-DD HH:mm:ss"
                            views={[
                              "year",
                              "day",
                              "hours",
                              "minutes",
                              "seconds",
                            ]}
                            renderInput={(params) => <TextField {...params} />}
                            ampm={false}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                    <div className="mr-2">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DateTimePicker", "DateTimePicker"]}
                        >
                          <DateTimePicker
                            label="End Month"
                            value={endMonth}
                            format="YYYY-MM-DD HH:mm:ss"
                            renderInput={(params) => <TextField {...params} />}
                            views={[
                              "year",
                              "day",
                              "hours",
                              "minutes",
                              "seconds",
                            ]}
                            ampm={false}
                            disabled={!startMonth}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className="mr-2">
                      <style>
                        {`
           .reports-content .dropdown-header > .mr-2 > div .MuiFormControl-root .MuiInputLabel-outlined {
            top: -9px !important;
            position: absolute;
        }
        
        .reports-content .dropdown-header > .mr-2 > div .MuiFormControl-root:focus-within .MuiInputLabel-outlined {
            top: 0 !important;
        }
         
        `}
                      </style>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DateTimePicker", "DateTimePicker"]}
                        >
                          <DateTimePicker
                            label="Start Index"
                            value={startIndex}
                            onChange={handleStartIndexChange}
                            format="YYYY-MM-DD HH:mm:ss"
                            views={[
                              "year",
                              "day",
                              "hours",
                              "minutes",
                              "seconds",
                            ]}
                            ampm={false}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                    <div className="mr-2">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DateTimePicker", "DateTimePicker"]}
                        >
                          <DateTimePicker
                            label="End Index"
                            value={endIndex}
                            onChange={handleEndIndexChange}
                            format="YYYY-MM-DD HH:mm:ss"
                            views={[
                              "year",
                              "day",
                              "hours",
                              "minutes",
                              "seconds",
                            ]}
                            ampm={false}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </Fragment>
                )}
                {selectedReport !== "summary" && (
                  <div className="mr-2">
                    <FormControl
                      fullWidth
                      style={{ width: "150px" }}
                      className="dropdownHeight"
                    >
                      <InputLabel>Select a Mnemonic</InputLabel>
                      <Select
                        value={selectedMnemonic}
                        onChange={handleMnemonicChange}
                        label="Select a Mnemonic"
                      >
                        <MenuItem value="all">ALL</MenuItem>
                        {selectedBusinessUnit === "all" &&
                        selectedDataProvider === "all" &&
                        selectedRig === "all" &&
                        selectedWell === "all" &&
                        selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .flat()
                                  .flatMap((dataProvider) => dataProvider.rigs)
                                  .flat()
                                  .flatMap((rig) => rig.wells)
                                  .flat()
                                  .flatMap((well) => well.logs)
                                  .flat()
                                  .flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map((mnemonic, index) => (
                              <MenuItem key={index} value={mnemonic}>
                                {mnemonic}
                              </MenuItem>
                            ))
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig !== "all" &&
                            selectedWell !== "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.find((rig) => rig.name === selectedRig)
                                  ?.wells.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  .logs.flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig !== "all" &&
                            selectedWell === "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.find((rig) => rig.name === selectedRig)
                                  ?.wells.flatMap((well) => well.logs)
                                  .flat()
                                  .flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig === "all" &&
                            selectedWell === "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.flatMap((rig) => rig.wells)
                                  ?.flat()
                                  .flatMap((well) => well.logs)
                                  .flat()
                                  .flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig === "all" &&
                            selectedWell === "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.flatMap(
                                    (dataProvider) => dataProvider.rigs
                                  )
                                  ?.flat()
                                  .flatMap((rig) => rig.wells)
                                  ?.flat()
                                  .flatMap((well) => well.logs)
                                  .flat()
                                  .flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig === "all" &&
                            selectedWell !== "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .flat()
                                  .flatMap((dataProvider) => dataProvider.rigs)
                                  ?.flat()
                                  .flatMap((rig) => rig.wells)
                                  ?.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig !== "all" &&
                            selectedWell !== "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .flat()
                                  .flatMap((dataProvider) => dataProvider.rigs)
                                  ?.find((rig) => rig.name === selectedRig)
                                  ?.wells.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig !== "all" &&
                            selectedWell !== "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.find((rig) => rig.name === selectedRig)
                                  ?.wells.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig !== "all" &&
                            selectedWell === "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.find((rig) => rig.name === selectedRig)
                                  ?.wells.flatMap((well) => well.logs)
                                  ?.flat()
                                  .flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig === "all" &&
                            selectedWell === "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.flatMap((rig) => rig.wells)
                                  ?.flat()
                                  .flatMap((well) => well.logs)
                                  .flat()
                                  .flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig !== "all" &&
                            selectedWell === "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .flat()
                                  .flatMap((dataProvider) => dataProvider.rigs)
                                  ?.find((rig) => rig.name === selectedRig)
                                  ?.wells.flatMap((well) => well.logs)
                                  .flat()
                                  .flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig !== "all" &&
                            selectedWell === "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.flatMap(
                                    (dataProvider) => dataProvider.rigs
                                  )
                                  ?.find((rig) => rig.name === selectedRig)
                                  ?.wells.flatMap((well) => well.logs)
                                  .flat()
                                  .flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig !== "all" &&
                            selectedWell !== "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.flatMap(
                                    (dataProvider) => dataProvider.rigs
                                  )
                                  ?.find((rig) => rig.name === selectedRig)
                                  ?.wells.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig === "all" &&
                            selectedWell !== "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.flatMap((rig) => rig.wells)
                                  ?.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.flatMap((log) => log.mnemonics)
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig === "all" &&
                            selectedWell !== "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.flatMap((rig) => rig.wells)
                                  ?.find((well) => well?.name === selectedWell)
                                  ?.logs.flatMap((log) => log?.mnemonics)
                                  ?.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig === "all" &&
                            selectedWell !== "all" &&
                            selectedLog === "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.flatMap(
                                    (dataProvider) => dataProvider.rigs
                                  )
                                  ?.flat()
                                  .flatMap((rig) => rig.wells)
                                  .find((well) => well?.name === selectedWell)
                                  ?.logs?.flatMap((log) => log?.mnemonics)
                                  ?.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig !== "all" &&
                            selectedWell !== "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.find((rig) => rig.name === selectedRig)
                                  ?.wells.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.find(
                                    (log) => log.name === selectedLogName
                                  )
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig !== "all" &&
                            selectedWell === "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.find((rig) => rig.name === selectedRig)
                                  ?.wells.flatMap((well) => well.logs)
                                  .find((log) => log.name === selectedLogName)
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig === "all" &&
                            selectedWell === "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.flatMap((rig) => rig.wells)
                                  ?.flat()
                                  .flatMap((well) => well.logs)
                                  .find((log) => log.name === selectedLogName)
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig === "all" &&
                            selectedWell === "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.flatMap(
                                    (dataProvider) => dataProvider.rigs
                                  )
                                  ?.flat()
                                  .flatMap((rig) => rig.wells)
                                  ?.flat()
                                  .flatMap((well) => well.logs)
                                  .find((log) => log.name === selectedLogName)
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig === "all" &&
                            selectedWell !== "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .flat()
                                  .flatMap((dataProvider) => dataProvider.rigs)
                                  ?.flat()
                                  .flatMap((rig) => rig.wells)
                                  ?.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.find(
                                    (log) => log.name === selectedLogName
                                  )
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig !== "all" &&
                            selectedWell !== "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .flat()
                                  .flatMap((dataProvider) => dataProvider.rigs)
                                  ?.find((rig) => rig.name === selectedRig)
                                  ?.wells.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.find(
                                    (log) => log.name === selectedLogName
                                  )
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig !== "all" &&
                            selectedWell !== "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.find((rig) => rig.name === selectedRig)
                                  ?.wells.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.find(
                                    (log) => log.name === selectedLogName
                                  )
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig !== "all" &&
                            selectedWell === "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.find((rig) => rig.name === selectedRig)
                                  ?.wells.flatMap((well) => well.logs)
                                  .find((log) => log.name === selectedLogName)
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig === "all" &&
                            selectedWell === "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.flatMap((rig) => rig.wells)
                                  ?.flat()
                                  .flatMap((well) => well.logs)
                                  .find((log) => log.name === selectedLogName)
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig !== "all" &&
                            selectedWell === "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .flat()
                                  .flatMap((dataProvider) => dataProvider.rigs)
                                  ?.find((rig) => rig.name === selectedRig)
                                  ?.wells.flatMap((well) => well.logs)
                                  .find((log) => log.name === selectedLogName)
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig !== "all" &&
                            selectedWell === "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.flatMap(
                                    (dataProvider) => dataProvider.rigs
                                  )
                                  ?.find((rig) => rig.name === selectedRig)
                                  ?.wells.flatMap((well) => well.logs)
                                  .find((log) => log.name === selectedLogName)
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig !== "all" &&
                            selectedWell !== "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.flatMap(
                                    (dataProvider) => dataProvider.rigs
                                  )
                                  ?.find((rig) => rig.name === selectedRig)
                                  ?.wells.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.find(
                                    (log) => log.name === selectedLogName
                                  )
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig === "all" &&
                            selectedWell !== "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.flatMap((rig) => rig.wells)
                                  ?.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.find(
                                    (log) => log.name === selectedLogName
                                  )
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider !== "all" &&
                            selectedRig === "all" &&
                            selectedWell !== "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .find(
                                    (dataProvider) =>
                                      dataProvider.name === selectedDataProvider
                                  )
                                  ?.rigs.flatMap((rig) => rig.wells)
                                  ?.find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.find(
                                    (log) => log.name === selectedLogName
                                  )
                                  .mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit !== "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig === "all" &&
                            selectedWell !== "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .find(
                                    (businessUnit) =>
                                      businessUnit.name === selectedBusinessUnit
                                  )
                                  ?.dataProviders.flatMap(
                                    (dataProvider) => dataProvider.rigs
                                  )
                                  ?.flat()
                                  .flatMap((rig) => rig.wells)
                                  .find(
                                    (well) => well.name === selectedWellName
                                  )
                                  ?.logs.flatMap((log) => log.mnemonics)
                                  .flat()
                                  .map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : selectedBusinessUnit === "all" &&
                            selectedDataProvider === "all" &&
                            selectedRig === "all" &&
                            selectedWell === "all" &&
                            selectedLog !== "all"
                          ? Array.from(
                              new Set(
                                reportFilterData.data.businessUnit
                                  .flatMap(
                                    (businessUnit) => businessUnit.dataProviders
                                  )
                                  .flat()
                                  .flatMap((dataProvider) => dataProvider.rigs)
                                  .flat()
                                  .flatMap((rig) => rig.wells)
                                  .flat()
                                  .flatMap((well) => well.logs)
                                  ?.find((log) => log.name === selectedLogName)
                                  ?.mnemonics.map((mnemonic) => mnemonic.name)
                              )
                            ).map(
                              (mnemonic, index) =>
                                mnemonic && (
                                  <MenuItem key={index} value={mnemonic}>
                                    {mnemonic}
                                  </MenuItem>
                                )
                            )
                          : ""}
                      </Select>
                    </FormControl>
                  </div>
                )}
                <div className="mr-2">
                  <Button
                    onClick={() => generateReport()}
                    // className="generate-report-btn"
                    style={{
                      padding: "5px 10px",
                      background: "linear-gradient(135deg, #4f4f4f, #1e1e1e)",
                      border: "1px solid #3a3a3a",
                      color: "#ffffff",
                      /* font-weight: 600; */
                      fontSize: "5px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
                      transition: "background 0.3s ease, transform 0.2s ease",
                    }}
                    type="button"
                    variant="contained"
                  >
                    Generate Report
                  </Button>
                </div>
                <div className="mr-2">
                  <Button
                    type="submit"
                    startIcon={<DownloadIcon />}
                    variant="contained"
                    style={{
                      padding: "5px 10px",
                      background: "linear-gradient(135deg, #4f4f4f, #1e1e1e)",
                      border: "1px solid #3a3a3a",
                      color: "#ffffff",
                      /* font-weight: 600; */
                      fontSize: "5px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
                      transition: "background 0.3s ease, transform 0.2s ease",
                    }}
                    onClick={handlePrint}
                    disabled={!reportComponent}
                  >
                    Download
                  </Button>
                </div>
                {/* <div className="mr-2">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                defaultChecked={false}
                                                checked={switchErrorValue}
                                                onChange={() => { setSwitchErrorValues(!switchErrorValue) }}

                                            />
                                        }
                                        label="Error values only"
                                    />
                                </div> */}
              </div>

              {showGenerateReportMessage && (
                <div
                  className="generateReportMsg"
                  style={{ position: "relative", height: "65vh" }}
                >
                  <p
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      color: "rgba(255, 255, 255, 0.8)",
                    }}
                  >
                    <b style={{ fontSize: "16px" }}>
                      Please click on Generate Report to generate Report
                    </b>
                  </p>
                </div>
              )}
              {showMessage && <p>Generating report. Please wait...</p>}
              {reportComponent && (
                <div
                  className="report-content"
                  id="report-content"
                  ref={componentRef}
                >
                  {reportComponent}
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </Fragment>
    )
  );
};

export default Reports;
